import React, { useEffect, useState, useMemo } from 'react'
import { Drawer, Descriptions, Image } from 'antd'
import type { DescriptionsProps } from 'antd'
// import {
//   AiPlatformEnum,
//   Dall3StyleList,
//   ImageModelVO,
//   StableDiffusionClipGuidancePresets,
//   StableDiffusionSamplers,
//   StableDiffusionStylePresets,
// } from '@/views/ai/utils/constants'
// import { formatTime } from '@/utils'

interface ImageDrawerProps {
  show: boolean
  data: any
  onClose: () => void
}

const ImageDetailDrawer: React.FC<ImageDrawerProps> = ({
  show,
  data,
  onClose,
}) => {
  const [visible, setVisible] = useState<boolean>(show)
  const [detail, setDetail] = useState<ImageVO | null>(null)

  /** 同步外部 show 状态 */
  useEffect(() => {
    setVisible(show)
  }, [show])

  /** 获取图片详情 */
  //   useEffect(() => {
  //     if (id) {
  //       ImageApi.getImageMy(id).then((res: ImageVO) => {
  //         setDetail(res)
  //       })
  //     }
  //   }, [id])

  /** 判断 StableDiffusion 参数 */
  const hasStableDiffusionOptions = useMemo(() => {
    const options = detail?.options
    return (
      options?.sampler ||
      options?.clipGuidancePreset ||
      options?.stylePreset ||
      options?.steps ||
      options?.scale ||
      options?.seed
    )
  }, [detail])

  /** 判断 Midjourney 参数 */
  const hasMidjourneyOptions = useMemo(() => {
    const options = detail?.options
    return options?.version || options?.referImageUrl
  }, [detail])

  const baseItems: DescriptionsProps['items'] = [
    // {
    //   key: 'createTime',
    //   label: '提交时间',
    //   children: detail?.createTime
    //     ? formatTime(detail.createTime, 'yyyy-MM-dd HH:mm:ss')
    //     : '-',
    // },
    // {
    //   key: 'finishTime',
    //   label: '生成时间',
    //   children: detail?.finishTime
    //     ? formatTime(detail.finishTime, 'yyyy-MM-dd HH:mm:ss')
    //     : '-',
    // },
    {
      key: 'model',
      label: '模型',
      children: `${detail?.model ?? 'wanx2.1-t2i-plus'} (${1200}x${1200})`,
    },
    {
      key: 'prompt',
      label: '提示词',
      children: <div style={{ wordBreak: 'break-word' }}>{data?.content}</div>,
    },
    {
      key: 'picUrl',
      label: '图片地址',
      children: (
        <div style={{ wordBreak: 'break-all', fontSize: 12 }}>
          {data?.medium?.images[0].url}
        </div>
      ),
    },
  ]

  return (
    <Drawer
      title="图片详细"
      open={visible}
      onClose={() => {
        setVisible(false)
        onClose()
      }}
      width={600}
      bodyStyle={{ paddingBottom: 80 }}
    >
      {/* 图片预览 */}
      <div style={{ marginBottom: 20 }}>
        {data?.medium?.images && (
          <Image
            src={data?.medium?.images[0].url}
            width="100%"
            style={{ borderRadius: 8 }}
            preview={{ src: data?.medium?.images[0].url }}
          />
        )}
      </div>

      {/* 基础信息 */}
      <Descriptions title="基础信息" column={1} bordered items={baseItems} />

      {/* StableDiffusion 参数 */}
      {/* {detail?.platform === AiPlatformEnum.STABLE_DIFFUSION &&
        hasStableDiffusionOptions && (
          <Descriptions
            title="StableDiffusion 参数"
            column={1}
            bordered
            style={{ marginTop: 20 }}
          >
            {detail?.options?.sampler && (
              <Descriptions.Item label="采样方法">
                {
                  StableDiffusionSamplers.find(
                    (item: ImageModelVO) =>
                      item.key === detail?.options?.sampler
                  )?.name
                }
              </Descriptions.Item>
            )}
            {detail?.options?.clipGuidancePreset && (
              <Descriptions.Item label="CLIP">
                {
                  StableDiffusionClipGuidancePresets.find(
                    (item: ImageModelVO) =>
                      item.key === detail?.options?.clipGuidancePreset
                  )?.name
                }
              </Descriptions.Item>
            )}
            {detail?.options?.stylePreset && (
              <Descriptions.Item label="风格">
                {
                  StableDiffusionStylePresets.find(
                    (item: ImageModelVO) =>
                      item.key === detail?.options?.stylePreset
                  )?.name
                }
              </Descriptions.Item>
            )}
            {detail?.options?.steps && (
              <Descriptions.Item label="迭代步数">
                {detail.options.steps}
              </Descriptions.Item>
            )}
            {detail?.options?.scale && (
              <Descriptions.Item label="引导系数">
                {detail.options.scale}
              </Descriptions.Item>
            )}
            {detail?.options?.seed && (
              <Descriptions.Item label="随机因子">
                {detail.options.seed}
              </Descriptions.Item>
            )}
          </Descriptions>
        )} */}

      {/* DALL·E 3 参数 */}
      {/* {detail?.platform === AiPlatformEnum.OPENAI && detail?.options?.style && (
        <Descriptions
          title="DALL·E 3 参数"
          column={1}
          bordered
          style={{ marginTop: 20 }}
        >
          <Descriptions.Item label="风格选择">
            {
              Dall3StyleList.find(
                (item: ImageModelVO) => item.key === detail?.options?.style
              )?.name
            }
          </Descriptions.Item>
        </Descriptions>
      )} */}

      {/* Midjourney 参数 */}
      {/* {detail?.platform === AiPlatformEnum.MIDJOURNEY &&
        hasMidjourneyOptions && (
          <Descriptions
            title="Midjourney 参数"
            column={1}
            bordered
            style={{ marginTop: 20 }}
          >
            {detail?.options?.version && (
              <Descriptions.Item label="模型版本">
                {detail.options.version}
              </Descriptions.Item>
            )}
            {detail?.options?.referImageUrl && (
              <Descriptions.Item label="参考图">
                <Image
                  src={detail.options.referImageUrl}
                  width={200}
                  style={{ borderRadius: 8 }}
                />
              </Descriptions.Item>
            )}
          </Descriptions>
        )} */}
    </Drawer>
  )
}

export default ImageDetailDrawer
